//All Employee Benefits
import {
  GET_PAYROLL_EMPLOYEE_BENEFITS_REQUEST,
  GET_PAYROLL_EMPLOYEE_BENEFITS_SUCCESS,
  GET_PAYROLL_EMPLOYEE_BENEFITS_ERROR,
} from "../../actions/employeesBenefits/getEmployeeBenefits";

//Create Employee Benefit
import {
  POST_PAYROLL_EMPLOYEE_BENEFIT_REQUEST,
  POST_PAYROLL_EMPLOYEE_BENEFIT_SUCCESS,
  POST_PAYROLL_EMPLOYEE_BENEFIT_ERROR,
} from "../../actions/employeesBenefits/postEmployeeBenefit";

//Logout
import { LOGOUT } from "../../../auth/actions/logout";

const INITIAL_STATE = {
  loading: false,
  loadingAction: false,
  loadingDetail: false,
  error: false,
  data: [],
  pagination: {
    current_page: 0,
    last_page: 0,
    per_page: 0,
    total: 0,
  },
  detail: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PAYROLL_EMPLOYEE_BENEFITS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_PAYROLL_EMPLOYEE_BENEFITS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: false,
        loading: false,
      };
    case GET_PAYROLL_EMPLOYEE_BENEFITS_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loading: false,
      };
    case POST_PAYROLL_EMPLOYEE_BENEFIT_REQUEST:
      return {
        ...state,
        error: false,
        loadingAction: true,
      };
    case POST_PAYROLL_EMPLOYEE_BENEFIT_SUCCESS:
      return {
        ...state,
        error: false,
        loadingAction: false,
      };
    case POST_PAYROLL_EMPLOYEE_BENEFIT_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loadingAction: false,
      };
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
